<template>
    <div class="min-h-8 flex items-center" data-testid="widget-title-container">
        <p
            v-if="title && showWidgetTitle"
            class="font-semibold truncate widget-header-title"
            data-testid="widget-title"
            :class="{ 'widget-title': !customFontSize }"
            :style="customFontSize"
        >
            <slot>
                {{ $t(title) }}
            </slot>
        </p>
    </div>
</template>
<script>
import get from 'lodash/get'
import { activeLayoutFontSize, showLayoutWidgetTitle } from '@/composables/globalData/useLayouts'
import { isPreviewLayout, widgetPreviewHeaderTextFontSize } from '@/composables/usePreviewLayout'
import { DEFAULT_FONT_SIZE_PX } from '@/enum/default-layout-config'

export default {
    name: 'BaseWidgetTitle',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        showWidgetTitle () {
            return showLayoutWidgetTitle.value
        },
        customFontSize () {
            const styles = isPreviewLayout.value ? widgetPreviewHeaderTextFontSize.value : activeLayoutFontSize.value
            const fontSize = get(styles, 'fontSize', '')
            if (!styles || fontSize === DEFAULT_FONT_SIZE_PX) {
                return
            }
            return {
                fontSize
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.widget-title {
    @apply text-lg;
}
</style>
